import React, { useRef, useState } from 'react';

const DELETE_WIDTH = 72;
const THRESHOLD = 50;

export default function SwipeableRow({ onDelete, children }) {
  const [tx, setTx] = useState(0);
  const [revealed, setRevealed] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [collapsing, setCollapsing] = useState(false);
  const startX = useRef(null);
  const startTx = useRef(0);

  const onTouchStart = (e) => {
    setIsAnimating(false);
    startX.current = e.touches[0].clientX;
    startTx.current = tx;
  };

  const onTouchMove = (e) => {
    if (startX.current === null) return;
    const dx = e.touches[0].clientX - startX.current;
    const newTx = Math.max(-DELETE_WIDTH - 4, Math.min(0, startTx.current + dx));
    setTx(newTx);
  };

  const onTouchEnd = () => {
    setIsAnimating(true);
    if (tx < -THRESHOLD) {
      setTx(-DELETE_WIDTH);
      setRevealed(true);
    } else {
      setTx(0);
      setRevealed(false);
    }
    startX.current = null;
  };

  const handleDelete = () => {
    setCollapsing(true);
    setTimeout(() => onDelete(), 280);
  };

  return (
    <div style={{
      maxHeight: collapsing ? 0 : 200,
      opacity: collapsing ? 0 : 1,
      overflow: 'hidden',
      transition: collapsing ? 'max-height 0.3s ease, opacity 0.25s ease, margin-bottom 0.3s ease' : 'none',
      marginBottom: collapsing ? 0 : 8,
    }}>
      <div style={{ position: 'relative', overflow: 'hidden', borderRadius: 12 }}>
        {/* Delete button (behind) — solo visible al hacer swipe */}
        <div
          onClick={handleDelete}
          style={{
            position: 'absolute', right: 0, top: 0, bottom: 0,
            width: DELETE_WIDTH,
            background: '#FFA500',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer',
            borderRadius: '0 12px 12px 0',
            zIndex: 3,
            opacity: Math.min(1, Math.abs(tx) / THRESHOLD),
          }}
        >
          <span style={{ fontSize: 22 }}>🗑</span>
        </div>

        {/* Overlay para cerrar swipe: NO cubre la zona de la papelera */}
        {revealed && (
          <div
            style={{ position: 'absolute', top: 0, left: 0, right: DELETE_WIDTH, bottom: 0, zIndex: 2 }}
            onClick={() => { setIsAnimating(true); setTx(0); setRevealed(false); }}
          />
        )}

        {/* Slideable content */}
        <div
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          style={{
            position: 'relative',
            zIndex: 4,
            transform: `translateX(${tx}px)`,
            transition: isAnimating ? 'transform 0.18s ease' : 'none',
            willChange: 'transform',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
